import $ from 'jquery';
import noop from 'cmnjs/function/noop';
import config from './config';

let $images;

let displayImages = function () {
  return config.showImages;
};

function loadSource(show, images) {
  if (show) {
    images.each(function () {
      $(this).attr('src', $(this).data('src'));
    });
  }
}

export default {

  init() {
    $images = $('.js-responsive-image');

    if (!$images.length) {
      displayImages = noop;
    }

    loadSource(displayImages(), $images);
  },

  resize(images) {
    loadSource(displayImages(), images);
  },
};



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/app/imageSwitcher.js